<template>
  <div class="layout-error">
    <alert />
    <md-button class="md-primary" @click="logout">Logout</md-button>
  </div>
</template>

<script>
import Alert from "@/pages/Layout/Alert.vue";
export default {
  components: {
    Alert
  },
  created() {
    this.$store.dispatch(
      "SHOW_ERROR_ALERT",
      [
        "The email address used to login (" +
          this.$auth.user.email +
          ") has not be linked to a Client in our system. Please contact admin@liftxconsult.com for assistance."
      ],
      { root: true }
    );
  },
  methods: {
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }
  }
};
</script>

<style>
html,
body {
  background-color: #fff !important;
}
.layout-error {
  padding: 10px;
}
</style>
